import userService from '@/api/user'
import { MessageBox, Message } from 'element-ui'


const user = {
    namespaced: true,
    state: {
        wechatNickName: '',
        userInfo: {},
        usedMemory: 0,
        memoryCapacity: 0,
        balanceCapacity: 0,
    },
    mutations: {
        setwechatNickName(state, wechatNickName) {
            state.wechatNickName = wechatNickName
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
            state.usedMemory = userInfo.usedMemory
            state.memoryCapacity = userInfo.memoryCapacity
            state.balanceCapacity = Number(userInfo.memoryCapacity) - Number(userInfo.usedMemory)
        },
        clear(state) {
            state.wechatNickName = ''
        }
    },
    actions:{
        updatedUserInfo({ commit, state }) {
            userService.info(res => {
                commit('setUserInfo',res.data[0])
            }, res => {
                Message.error(res.message)
            })
        },
    }
}

export default user